import { Button } from '@/components/ui/button'
import { TableCell, TableRow } from '@/components/ui/table'
import type { IncomeDrillMetric, IncomeInvoiceDrillDown } from '@/lib/incomeInvoiceDrillDown'

interface IncomeAmounts {
  invoice_count: number
  gross: string
  discount: string
  tax: string
  net: string
}

export function IncomeDrillDownAmountsRow({
  label,
  displayLabel,
  amounts,
  className,
  onDrillDown,
  scope,
  total = false,
}: {
  label: string
  displayLabel?: string
  amounts: IncomeAmounts
  className: string
  onDrillDown: (drillDown: IncomeInvoiceDrillDown) => void
  scope: Pick<
    IncomeInvoiceDrillDown,
    'startsOn' | 'endsOn' | 'grouping' | 'granularity' | 'groupKey'
  >
  total?: boolean
}) {
  return (
    <TableRow className={total ? 'border-t-2 font-semibold hover:bg-transparent' : 'font-medium'}>
      <TableCell className={className}>{displayLabel ?? label}</TableCell>
      {(['gross', 'discount', 'tax', 'net'] as IncomeDrillMetric[]).map((metric) => (
        <TableCell key={`${label}-${metric}`} className="text-right tabular-nums">
          <Button
            type="button"
            variant="link"
            size="inline"
            aria-label={`Drill down ${label} ${metric} ${amounts[metric]}`}
            onClick={() =>
              onDrillDown({
                label,
                metric,
                amount: amounts[metric],
                invoiceCount: amounts.invoice_count,
                ...scope,
              })
            }
          >
            {amounts[metric]}
          </Button>
        </TableCell>
      ))}
    </TableRow>
  )
}
